import React from "react";
import { Link } from "react-router-dom";

const Forbidden = () => (
    <main className="container py-5">
        <h1>Acesso negado</h1>
        <p>Você não possui permissão para acessar esta área.</p>
        <Link to="/ctop/clientes" className="btn btn-primary">
            Ir para Clientes
        </Link>
    </main>
);

export default Forbidden;
